import React from "react";
import { config } from "../../utils/config";

export default function ViewCard({ data, onClick, isFieldDisabled, display }) {
  return (
    <div
      style={{
        cursor: isFieldDisabled === true ? "not-allowed" : "pointer",
      }}
      onClick={(e) => {
        if (onClick != null) {
          onClick(e);
        }
      }}
      className={`${
        display ? "w-full" : "w-full max-w-[236px] border border-gray-200"
      } rounded-xl overflow-hidden shadow bg-white`}
    >
      {/* Image - no padding */}
      <div className="w-full aspect-[16/9] bg-gray-100">
        {data?.imageUrl ? (
          <img
            src={`${config.apiUrl}/assets/${data.imageUrl}`}
            alt={data?.name || "Vehicle"}
            className="w-full h-full object-cover object-center"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-sm text-gray-400">
            No Image
          </div>
        )}
      </div>

      {/* Content - padded */}
      <div className="p-4 text-left">
        <h3 className="font-semibold text-base text-black mb-1">
          {data?.name}
        </h3>

        <p className="text-sm text-gray-700">
          <span className="font-semibold">Category:</span> {data?.subTitle}
        </p>
      </div>
    </div>
  );
}
